import {createSelector} from 'reselect/lib/index';

export const getTotalRMDAmount = (state) => {
  return state.RMDSetting.rmdLimitsData
    ? state.RMDSetting.rmdLimitsData.totalRMD
    : 0;
};

export const getEligibleForRMD = (state) => {
  return state.RMDSetting.rmdLimitsData?.eligibleForRMD
    ? state.RMDSetting.rmdLimitsData?.eligibleForRMD
    : false;
};

export const getFirstRMDDeadline = (state) => {
  return state.RMDSetting.rmdLimitsData?.firstRMDDeadline;
};

export const getLastBusinessDayOfYear = (state) => {
  return state.RMDSetting.rmdLimitsData?.lastBusinessDayOfYear;
};

export const getRemainingRMDAmount = (state) => {
  return state.RMDSetting.rmdLimitsData
    ? state.RMDSetting.rmdLimitsData.amountToBeDistributed
    : 0;
};

export const getBeneficiaries = (state) =>
  state.RMDSetting.rmdLimitsData
    ? state.RMDSetting.rmdLimitsData.rmdBeneficiaries
    : [];

export const getRMDSummary = (state) =>
  state.RMDSetting ? state.RMDSetting.rmdLimitsData : {};

// export const getLastBusinessDay = createSelector(
//   getRMDSummary,
//   (rmdSummary) => {
//     return rmdSummary?.lastbusinessday;
//   }
// );

export const getExistingRMDinfo = (state) =>
  state.RMDSetting ? state.RMDSetting.existingRMDData : [];
// export const getIsExistingPending = state => state.RMDSetting ? state.RMDSetting?.existingRMDDataPending?.pending : false //?.existingRMDDatePending?.pending : false;
/*export const getIsDisbursementType = createSelector(
  getOnlyOWNRRMDs,
  (existingRMDs) => {
    return (
      existingRMDs  ? existingRMDs.length > 0 : false
    );
  }
);*/
export const getFinalRMDDate = createSelector(
  getExistingRMDinfo,
  (existingRMDs) => {
    return existingRMDs[0]?.transferDays[
      existingRMDs[0]?.transferDays.length - 1
    ];
  }
);

export const getFinalRMDMonth = createSelector(
  getExistingRMDinfo,
  (existingRMDs) => {
    const allMonths = existingRMDs[0]?.transfers.map((transfer) => {
      return transfer.month;
    });
    return allMonths?.[allMonths?.length - 1];
  }
);

export const getIsRMDPending = createSelector(
  getExistingRMDinfo,
  (existingRMDs) => {
    if (existingRMDs && existingRMDs.length > 0) {
      return {
        pending: existingRMDs[0].pending,
        type: existingRMDs[0].featureStatus.enumerationID,
      };
    } else {
      return {
        pending: false,
        type: null,
      };
    }
  }
);

export const getIsRMDBalanceAndAmountIsZero = createSelector(
  getRMDSummary,
  (rmdLimitsData) => {
    if (rmdLimitsData && rmdLimitsData.rmdAgreements?.length > 0) {
      return rmdLimitsData.rmdAgreements.some(
        (agreement) =>
          agreement.availableEquity === 0 && agreement.rmdamount === 0
      );
    }
    return false;
    return false;
  }
);

export const getRMDAgreements = (state) =>
  state.RMDSetting?.rmdLimitsData?.rmdAgreements
    ? state.RMDSetting.rmdLimitsData.rmdAgreements
    : [];

export const getRMDFactorAmount = createSelector(
  getRMDSummary,
  (rmdLimitsData) => {
    let factorAmount = rmdLimitsData?.rmdAgreements?.map((agreement) => {
      return agreement?.factorAmount;
    });

    factorAmount = factorAmount?.filter((age) => {
      return age !== 0;
    });
    //lodash isn't installed this pulls unique values
    return [...new Set(factorAmount)];
  }
);

export const getRMDFactorTableUniformDistribution = createSelector(
  getRMDSummary,
  (rmdLimitsData) => {
    let factorTable = rmdLimitsData?.rmdAgreements?.map((agreement) => {
      return agreement?.factorTable;
    });

    factorTable = factorTable.every((table) => {
      return table === 'UNIFORM_DISTRIBUTION';
    });

    return factorTable;
  }
);

export const getRMDFactorTableLifeExpectancy = createSelector(
  getRMDSummary,
  (rmdLimitsData) => {
    let factorTable = rmdLimitsData?.rmdAgreements?.map((agreement) => {
      return agreement?.factorTable;
    });

    factorTable = factorTable.every((table) => {
      return table === 'LIFE_EXPECTANCY';
    });

    return factorTable;
  }
);

export const getRMDFactorTableBoth = createSelector(
  getRMDSummary,
  (rmdLimitsData) => {
    const factorTable = rmdLimitsData?.rmdAgreements?.map((agreement) => {
      return agreement?.factorTable;
    });

    const factorTableLE = factorTable.some((table) => {
      return table === 'LIFE_EXPECTANCY';
    });

    const factorTableUD = factorTable.some((table) => {
      return table === 'UNIFORM_DISTRIBUTION';
    });
    return factorTableLE && factorTableUD;
  }
);

export const allTransactionsFromHistory = (state) => {
  return state?.RecentTransactions?.data;
};
export const hasRothConverseionOnRmdAgreements = createSelector(
  getRMDSummary,
  ({ preRMDEligible, ytdconversion }) => {
    return !preRMDEligible && !ytdconversion;
  }
);

export const getShowDashboard = (state) =>
  state.RMDSetting && state.RMDSetting.showDashboard !== undefined
    ? state.RMDSetting.showDashboard
    : true;

export const getDashboardStatus = (state) =>
  state.RMDSetting ? state.RMDSetting.dashboardStatus : null;
